import React, { useEffect, useState } from 'react'

import { getPurposeCopy, patchAccountConsent } from '../../../../api'
import { Consent } from '../../../../api/AccountConsent/getAccountConsents'
import { Purpose } from '../../../../api/AccountConsent/getPurposeCopy'

import { Dialog } from './Dialog'
import { removeConsentCookie } from './pure'

type DialogProviderProps = {
  accountId: string
  consent: Consent
}

export const DialogProvider: React.FC<DialogProviderProps> = ({ accountId, consent }) => {
  const [purpose, setPurpose] = useState<Purpose | null>(null)

  useEffect(() => {
    ;(async () => {
      setPurpose(await getPurposeCopy())
    })()
  }, [])

  if (!purpose) return null

  return (
    <Dialog
      purpose={purpose}
      accept={async () => {
        await patchAccountConsent(accountId, {
          isAccepted: true,
          version: purpose.version,
        })
        removeConsentCookie(consent.id, accountId)
      }}
      decline={async () => {
        await patchAccountConsent(accountId, {
          isAccepted: false,
          version: purpose.version,
        })
        removeConsentCookie(consent.id, accountId)
      }}
    />
  )
}
